import { takeLatest, put, call, takeEvery } from "redux-saga/effects";
import { PAYMENTS } from "../actions/types";
import { toast } from "react-toastify";
import { logout } from "../actions/Auth";
import {
  fetchNetworkSuccess,
  fetchDataProviderSuccess,
  fetchDataSubscriptionSuccess,
  fetchTvProvidersSuccess,
  fetchTvSubscriptionSuccess,
  fetchElectricitySubSuccess,
} from "../actions/payments";
import history from "../../helpers/history";
import axios from "axios";
import { loadingFinish } from "../actions/Loading";
import { updateProfile } from "../actions/Settings";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;

function* handleFetchNetwork() {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/airtime/list`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(fetchNetworkSuccess(result.data.data));
    } else {
      toast.error("An error ocurred while fetching network providers");
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  }
}

function* handleAirtimeRecharge({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/airtime/buy`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("disable", true);
      const date = new Date();

      const today = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth()
      ).padStart(2, "0")}-${date.getFullYear()}`;

      const time = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

      sessionStorage.setItem(
        "date",
        JSON.stringify({ time, today, description: "Airtime Recharge" })
      );
      setTimeout(() => {
        history.push("/agent/payments/airtime/success");
      }, 1000)
      
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleFetchDataProvider() {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/data/recharge/list`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(fetchDataProviderSuccess(result.data.data));
    } else {
      toast.error("An error ocurred while fetching data providers");
    }
  } catch (err) {
    let error = err;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  }
}

function* handleFetchDataSubscription({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/data/recharge/bundle/list`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          service_id: payload,
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(
        fetchDataSubscriptionSuccess(result.data.data.content.varations)
      );
    } else {
      toast.error("An error ocurred while fetching subscription");
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  }
}

function* handleBuyData({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/data/recharge/buy`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("disable", true);
      const date = new Date();
      const today = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth()
      ).padStart(2, "0")}-${date.getFullYear()}`;
      const time = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
      sessionStorage.setItem(
        "date",
        JSON.stringify({ time, today, description: "Data Recharge" })
      );
      history.push("/agent/payments/data/success");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleFetchTvProviders() {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/tv/subscription/list`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(fetchTvProvidersSuccess(result.data.data));
    } else {
      toast.error("An error ocurred while fetching TV providers");
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  }
}

function* handleFetchTvSubscription({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/tv/subscription/bundle/list`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          tv_subscription_type: payload,
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(fetchTvSubscriptionSuccess(result.data.data.content.varations));
    } else {
      toast.error("An error ocurred while fetching TV subscription");
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  }
}

function* handleVerifyCard({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/tv/subscription/verify`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.data.content.error) {
      toast.error(result.data.data.content.error);
      sessionStorage.removeItem("tv-subscription");
    }

    if (result.data.data.content.Customer_ID) {
      const info = { ...payload, ...result.data.data.content };
      sessionStorage.setItem("tv-subscription", JSON.stringify(info));
      history.push("/agent/payments/tv/confirm");
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
      toast.error(error);
    }
  } finally {
    yield put(loadingFinish());
  }
}

function* handleBuyTvSub({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/tv/subscription/buy`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("disable", true);
      const date = new Date();
      const today = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth()
      ).padStart(2, "0")}-${date.getFullYear()}`;
      const time = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
      sessionStorage.setItem(
        "date",
        JSON.stringify({ time, today, description: "TV Subscription" })
      );
      history.push("/agent/payments/tv/success");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleFetchElectricitySub({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/electricity/subscription/list`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(fetchElectricitySubSuccess(result.data.data));
    } else {
      toast.error("An error ocurred while fetching data providers");
    }
  } catch (err) {
    let error = err;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  }
}

function* handleVerifyMeter({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/electricity/subscription/verify`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.data.content.error) {
      toast.error(result.data.data.content.error);
      sessionStorage.removeItem("electricity-subscription");
    }

    if (result.data.data.content.Customer_Name) {
      const info = { ...payload, ...result.data.data.content };
      sessionStorage.setItem("electricity-subscription", JSON.stringify(info));
      history.push("/agent/payments/electricity/confirm");
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
      toast.error(error);
    }
  } finally {
    yield put(loadingFinish());
  }
}

function* handleBuyElecticitySubs({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/vas/electricity/subscription/buy`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("disable", true);
      const date = new Date();
      const today = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth()
      ).padStart(2, "0")}-${date.getFullYear()}`;
      const time = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
      sessionStorage.setItem(
        "date",
        JSON.stringify({
          time,
          today,
          description: "Electricity Subscription",
          token: result.data.data.token,
        })
      );
      history.push("/agent/payments/electricity/success");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

export default [
  takeLatest(PAYMENTS.FETCH_NETWORK, handleFetchNetwork),
  takeLatest(PAYMENTS.BUY_AIRTIME, handleAirtimeRecharge),
  takeLatest(PAYMENTS.FETCH_DATA_PROVIDER, handleFetchDataProvider),
  takeLatest(PAYMENTS.FETCH_DATA_SUBSCRIPTION, handleFetchDataSubscription),
  takeLatest(PAYMENTS.BUY_DATA, handleBuyData),
  takeLatest(PAYMENTS.FETCH_TV_PROVIDERS, handleFetchTvProviders),
  takeLatest(PAYMENTS.FETCH_TV_SUBSCRIPTIONS, handleFetchTvSubscription),
  takeEvery(PAYMENTS.VERIFY_CARD, handleVerifyCard),
  takeLatest(PAYMENTS.BUY_TV_SUB, handleBuyTvSub),
  takeLatest(PAYMENTS.FETCH_ELECTRICITY_SUB, handleFetchElectricitySub),
  takeLatest(PAYMENTS.VERIFY_METER_NUMBER, handleVerifyMeter),
  takeLatest(PAYMENTS.BUY_ELECTRICITY_SUB, handleBuyElecticitySubs),
];
